import(/* webpackMode: "eager" */ "/home/runner/work/eForm/eForm/frontend/src/app/layout.tsx");
